/**
 * Studio Analytics - Redirect to Intelligence Hub
 * Solis Games - Updated for Phase 2.2
 */

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { supabase } from '../../utils/supabase';

const StudioAnalytics = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    redirectToIntelligenceHub();
  }, [user]);

  const redirectToIntelligenceHub = async () => {
    if (!user) {
      navigate('/user-login');
      return;
    }

    try {
      // Get user's studio
      const { data: studios } = await supabase
        .from('gaming_studios')
        .select('id')
        .eq('owner_id', user.id)
        .limit(1)
        .single();

      if (studios) {
        navigate(`/studio/${studios.id}/analytics`);
      } else {
        navigate('/');
      }
    } catch (error) {
      console.error('Error redirecting to Intelligence Hub:', error);
      navigate('/');
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-muted-foreground">Redirecting to Intelligence Hub...</p>
      </div>
    </div>
  );
};

export default StudioAnalytics;
